import React from 'react'
import styled from 'styled-components'


const Area = styled.div`
    display: flex;
    width: 100%;
    margin: auto;
    flex-direction:  ${props => props.direction !== '' ? props.direction : 'row'};
    align-items: ${props => props.align !== '' ? props.align : 'stretch'};
`

const Content = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    height: ${props => props.height ? props.height : 'auto'};

    ${
     props => props.background && `
        background-image: url(${props.background});
        background-size: cover;
        background-position: center;
     `
    }
    

    @media only screen and (max-width: 768px) {
       height: auto;
    }
`

const Section = (props) => {

    return (
        <Content height={props.height} className={props.className} id={props.id} style={props.style} background={props.background}>
            {!props.backgropund && <Area direction={props.direction} align={props.align} justify={props.justify}>
                {props.children}
            </Area>}
        </Content>
    )
}

export default Section